import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IOrderHistoryView} from '../orders-models';
import {Util} from "../../util/util";

@Component({
    selector: 'order-history-tracking',
    templateUrl: './order-history-tracking.component.html',
    styleUrls: ['../orders.scss', './order-history-tracking.component.scss'],
    standalone: false
})
export class OrderHistoryTrackingComponent {
	@Input() orderView: IOrderHistoryView;
	@Output() readonly onClose = new EventEmitter();

	close() {
		this.onClose.emit();
	}

    trackByFn(index: any) {
        return Util.trackByFn(index);
    }
}
